import ScoringType from "../../enums/ScoringType.js";
import scoringTypeNotIn from "../scoringType/scoringTypeNotIn.js";
import sessionCouldHaveNewScoringData from "../sessionContents/sessionCouldHaveNewScoringData.js";
import gameOrScrimmageSessionType from "../sessionType/gameOrScrimmage.js";
import sessionClassifierBuilder from "./sessionClassifierBuilder.js";

const scoringTypes = [ScoringType.extendedTagging.key];

const notExtendedTaggingPredicate = function(sessionData) {
    return scoringTypeNotIn(sessionData, scoringTypes);
};

const sessionWithoutExtendedTagging = sessionClassifierBuilder(
    gameOrScrimmageSessionType, sessionCouldHaveNewScoringData, undefined, notExtendedTaggingPredicate
);

export default sessionWithoutExtendedTagging;